<script lang="ts">
	// shadcn-svelte Dialog header layout — a plain flex column for title + description.
	import type { HTMLAttributes } from "svelte/elements";
	import { cn, type WithElementRef } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props();
</script>

<div
	bind:this={ref}
	data-slot="dialog-header"
	class={cn("flex flex-col gap-1.5", className)}
	{...restProps}
>
	{@render children?.()}
</div>
